import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { PlayerTrackingHistoryData } from '@modules/players/submodules/PlayerProfile/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { PLAYERS_PERMISSIONS } from '@modules/players/constants';
import { PLAYER_HISTORY_API_URL, PLAYER_HISTORY_QUERY_KEY } from '@modules/players/submodules/PlayerProfile/constants';

export default function usePlayerTrackingHistoryQuery(
  playerId: Ref<string | undefined>,
  historyId: Ref<number | undefined>,
  merchant: Ref<number | undefined>,
): IContextQueryResult<PlayerTrackingHistoryData, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [PLAYER_HISTORY_QUERY_KEY, playerId, historyId, merchant],
    queryFn: () => fetchGet<PlayerTrackingHistoryData>(
      PLAYER_HISTORY_API_URL,
      {
        permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
        urlParams: {
          playerId: playerId.value,
          historyId: historyId.value,
        },
        queryParams: {
          merchant: merchant.value,
        },
      },
    ),
    enabled: computed(() => !!(playerId.value && historyId.value && merchant.value)),
  });
}
